import IMapBiuraServiceConfig from '../../types/IMapBiuraServiceConfig';
import IMapBiuroSzczegolyServiceConfig from '../../types/IMapBiuroSzczegolyServiceConfig';
import IMapEventListenerParams from '../../types/IMapEventListenerParams';

const addEventListenerToMapFullyLoaded = (params: IMapEventListenerParams<IMapBiuraServiceConfig | IMapBiuroSzczegolyServiceConfig>) => {
  const { serviceConfig, gmap } = params;
  const { config } = serviceConfig;

  google.maps.event.addDomListenerOnce(gmap, 'tilesloaded', () => {
    config.isFullyLoaded = true;
  });
};
export default addEventListenerToMapFullyLoaded;
